import React from "react";
import HomeComp from "../components/home-comp/HomeComp";

const IndexPage = () => <HomeComp />;

export default IndexPage;
